<template>
  <div>
    <label class="field_label">{{ current_champ.label }}<span class="text-red"
        v-if="current_champ.mandatory == 1">*</span></label>
    <v-select :items="items" @change="change_identity_current_coureur(current_champ.nom)" v-model="current_champ.value"
      ref="field" @blur="$refs.field.validate()" :disabled="current_champ.disabled || is_disable"
      :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode)]"></v-select>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
  props: ["champ", "inscription", "mode", "is_disable"],
  data() {
    return {
      current_champ: {},
      items: [],
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  watch: {
    champ: {
      deep: true,
      handler() {
        this.current_champ = this.champ;
        this.change_identity_current_coureur(this.current_champ.nom);
        this.$forceUpdate();
      },
    },
    "inscription.list_courses": {
      deep: true,
      handler() {
        if (this.current_champ.nom === "sexe") {
          this.validate_field();
        }
      },
    },
  },
  methods: {
    validate_field() {
      this.$nextTick(() => {
        this.$refs.field?.validate();
      });
    },

    change_identity_current_coureur(champ) {
      let identity_champs = ["nom", "prenom", "date_naissance", "sexe"];
      if (identity_champs.includes(champ) && this.inscription.coureur.id != null) {
        this.$emit("change_identity_coureur", this.inscription.coureur);
      }
      if (champ === "sexe") {
        this.validate_field();
      }
    },

    populateSelect() {
      this.items = [];
      switch (this.current_champ.nom) {
        case "sexe":
          this.items = this.$itemsSelect.sexe();
          break;
        case "pays":
          this.items = this.$itemsSelect.pays();
          break;
        case "nationalite":
          this.items = this.$itemsSelect.pays();
          break;
        default:
          this.items = this.$itemsSelect.getSelection(this.current_champ.options);

          break;
      }
    },
    async get_selection_with_metadatas() {
      let availables_items = [];
      let availabilities = await this.current_champ.get_selection_with_metadatas();

      for (let i = 0; i < availabilities.length; i++) {
        let nb_local_selection = this.get_nb_local_selection(availabilities[i].id_champ, availabilities[i].value);
        availabilities[i].remaining = parseInt(availabilities[i].remaining) - parseInt(nb_local_selection);
        if (availabilities[i].remaining > 0) {
          availables_items.push(availabilities[i].value);
        }
      }



      let availables_items_joins = availables_items.join(";");
      this.current_champ.options = availables_items_joins;

      this.items = this.$itemsSelect.getSelection(availables_items_joins);

    },
    get_nb_local_selection(id, value) {
      let nb_local_selection = 0;
      const inscriptions = this.mainStore.bookingSystem.booking.inscriptions;
      for (let i = 0; i < inscriptions.length; i++) {
        const inscription = inscriptions[i];
        // iterate over inscription.champs object
        for (const obj of Object.entries(inscription.coureur.champs)) {

          if (obj[1].id == id && obj[1].value == value) {
            nb_local_selection++;
          }
        }
      }

      return nb_local_selection;
    },
  },
  async created() {
    this.current_champ = this.champ;

    if (this.current_champ.has_metadatas == "0") {
      this.populateSelect();
    }
    else {
      await this.get_selection_with_metadatas();
    }

  },
};
</script>

<style lang="scss">
.v-autocomplete__content {
  max-height: 300px !important;
  min-height: auto !important;
}
</style>